const API_URL = process.env.VUE_APP_API_URL;
const PORTAL = process.env.VUE_APP_PORTAL;
const API_URL_ARCHIVOS = process.env.VUE_APP_API_URL_ARCHIVOS;

import LUM from "@/lib/LUM.js";
import { _ } from "core-js";
export default {
  API_URL: process.env.VUE_APP_API_URL,
  API_URL_ARCHIVOS: process.env.VUE_APP_API_URL_ARCHIVOS,
  Portal: process.env.VUE_APP_PORTAL,
  Aportesafiliado: {
    async traerPorCuil(cuil) {
      return LUM.get(API_URL + "Aportesafiliado/traerPorCuil/" + cuil);
    }
  },
  Areas: {
    async traerTodos() {
      return LUM.get(API_URL + "Areas");
    }
  },
  Autorizaciones: {
    async traerPorAfiliado(id_afiliado) {
      return LUM.get(
        API_URL + "Autorizaciones/traerPorAfiliado/" + id_afiliado
      );
    },
    async traerPorAfiliadoyEfector(id_afiliado, id_efector) {
      return LUM.get(
        `${API_URL}Autorizaciones/traerPorAfiliadoyEfector/${id_afiliado}/${id_efector}`
      );
    },
    async traerPorArea(id_area) {
      return LUM.get(API_URL + "Autorizaciones/traerPorArea/" + id_area);
    },
    async traerPorAreaPaginado(
      id_area,
      pagina,
      filtroTipo,
      filtroid_solic,
      filtroafiliado,
      filtropractica,
      filtroefector,
      filtroconvenio,
      filtroprovincia,
      filtroplan
    ) {
      return LUM.getPagina(
        API_URL +
          "Autorizaciones/traerPorAreaPaginado/" +
          id_area +
          "/" +
          pagina +
          `?tipo=${filtroTipo ?? 0}&id_solic=${filtroid_solic ?? 0}&afiliado=${
            filtroafiliado ?? ""
          }&practica=${filtropractica ?? ""}&efector=${
            filtroefector ?? ""
          }&convenio=${filtroconvenio ?? -1}&provincia=${filtroprovincia ?? -1}&idplan=${filtroplan ?? -1}`
      );
    },
    async traerUna(id_solic) {
      return LUM.get(API_URL + "Autorizaciones/" + id_solic);
    },
    async traerUltimas() {
      return LUM.get(API_URL + "Autorizaciones/traerUltimas");
    },
    async traerPorEfector(id) {
      return LUM.get(API_URL + "Autorizaciones/traerPorEfector/" + id);
    },
    async traerPorFiltros(id_afiliado, id_efector, fecha, id_solic, estado) {
      return LUM.get(
        `${API_URL}Autorizaciones/traerPorFiltros/${id_afiliado}/${id_efector}/${fecha}/${id_solic}/${estado}`
      );
    },
    async traerPorFiltrosConvenios(id_convenio, fecha) {
      return LUM.get(
        `${API_URL}Autorizaciones/traerPorFiltrosConvenios/${id_convenio}/${fecha}`
      );
    },
    async modificar(entidad) {
      return LUM.put(API_URL + "Autorizaciones", entidad);
    },
    async revalidar(idsolic) {
      return LUM.put(API_URL + "Autorizaciones/revalidar/" + idsolic);
    },
    async alta(entidad) {
      return LUM.post(API_URL + "Autorizaciones", entidad);
    },
    async evaluarEstado(
      id_afiliado,
      cantidad,
      id_practica,
      id_efector,
      id_efectorprofesional
    ) {
      return LUM.get(
        API_URL +
          `Autorizaciones/evaluarEstado/${id_afiliado}/${cantidad}/${id_practica}/${id_efector}/${id_efectorprofesional}`
      );
    },
    async anular(id_solic) {
      return LUM.get(API_URL + `Autorizaciones/anular/${id_solic}`);
    },
    async ultimavez(id_solic, id_afiliado, id_practica) {
      return LUM.get(
        API_URL +
          `Autorizaciones/ultimavez/${id_solic}/${id_afiliado}/${id_practica}`
      );
    },
    async traerCoseguroPractica(id_practica, id_afiliado, fecha, cantidad) {
      return LUM.get(
        `${API_URL}Autorizaciones/traerCoseguroPractica/${id_practica}/${id_afiliado}/${fecha}/${cantidad}`
      );
    },
    async calcularCoseguroLineas(id_solic) {
      return LUM.get(
        API_URL + "Autorizaciones/calcularCoseguroLineas/" + id_solic
      );
    }
  },
  AutorizacionesTomadas: {
    async tomar(id_solic) {
      //return LUM.get(API_URL + 'Default/' + id_solic)
      return LUM.post(API_URL + "Tomadas/", {
        id_solic,
        id_user: 0
      });
    },
    async soltar(id_solic) {
      return LUM.delete(API_URL + "Tomadas/" + id_solic);
    }
  },
  Beneficiarios: {
    Nuevo() {
      let b = {
        nro_afi: 0,
        parent: "",
        apellido_y_nombre: "",
        fecha_nacimiento: "",
        id_tipo_afiliacion: 0,
        incapacitado: "",
        calle: "",
        nro: "",
        piso: "",
        dpto: "",
        torre: "",
        circ: "",
        manzana: "",
        codigo_postal: "",
        id_provincia: 0,
        id_localidad: 0,
        id_seccional: 0,
        telefono: "",
        mail: "",
        fecha_alta: "",
        celular: "",
        telefono_laboral: "",
        sexo: "",
        id_nacionalidad: 0,
        id_estado_civil: 0,
        id_convenio_prestacional: 0,
        credencial: "",
        contrato_laboral: "",
        id_zona: 0,
        id_sit_revista: 0,
        pmi: "",
        nro_beneficio_anses: 0,
        cuil: "",
        id_tipo_documento: 0,
        nro_doc: "",
        fecha_baja: "",
        id_motivo_baja: 0,
        fecha_certificado_discapacidad: "",
        fecha_fin_cobertura: "",
        fecha_movimiento: "",
        id_usuario_alta: 0,
        id_usuario_modifica: 0,
        id_usuario_baja: 0,
        fecha_apl_baja: "",
        id_afiliado: 0,
        id_parentesco: 0
      };
      return b;
    },
    async Buscar(nombreodni, titular) {
      if (titular) {
        return LUM.get(
          API_URL + "beneficiarios/traerTitularesPorNombreoDNI/" + nombreodni
        );
      } else {
        return LUM.get(
          API_URL + "beneficiarios/traerPorNombreoDNI/" + nombreodni
        );
      }
    },
    async Validar(dni, fec_nac) {
      return LUM.get(`${API_URL}beneficiarios/validar/${dni}/${fec_nac}`);
    },
    async traerUno(id) {
      return LUM.get(API_URL + "beneficiarios/" + id);
    },
    async BuscarNombreNroDNI(nombreodnioNroAfi) {
      return LUM.get(
        API_URL +
          "beneficiarios/traerPorNombreoDNIoNroAfi/" +
          nombreodnioNroAfi +
          "=="
      );
    },
    async BuscarTitularNombreNroDNI(nombreodnioNroAfi) {
      return LUM.get(
        API_URL +
          "beneficiarios/traerTitularPorNombreoDNIoNroAfi/" +
          nombreodnioNroAfi
      );
    },
    async BuscarNombreNroDNIOspetax(nombreodnioNroAfi) {
      return LUM.get(
        API_URL + "beneficiarios/traerBeneficiarioOspetax/" + nombreodnioNroAfi
      );
    },
     async BuscarNombreNroDNIOspical(nombreodnioNroAfi) {
      return LUM.get(
        API_URL + "beneficiarios/traerBeneficiarioOspical/" + nombreodnioNroAfi
      );
    },
    async traerPorNombre(nombre) {
      return LUM.get(API_URL + "beneficiarios/traerPorNombre/" + nombre);
    },
    async traerTitularesPorNombre(nombre) {
      return LUM.get(
        API_URL + "beneficiarios/traerTitularesPorNombre/" + nombre
      );
    },
    async traerTitularesPorDNI(nombre) {
      return LUM.get(API_URL + "beneficiarios/traerTitularesPorDNI/" + nombre);
    },
    async traerPorAfiyParent(nroafi, parent) {
      return LUM.get(
        API_URL + "beneficiarios/traerPorAfiyParent/" + nroafi + "/" + parent
      );
    },
    async traerPorAfi(nroafi) {
      return LUM.get(API_URL + "beneficiarios/traerPorAfi/" + nroafi);
    },
    async traerPorDNI(dni) {
      return LUM.get(API_URL + "beneficiarios/traerPorDNI/" + dni);
    },
    async traerPorDNIdeAlta(dni) {
      return LUM.get(API_URL + "beneficiarios/traerPorDNIdeAlta/" + dni);
    },
    traerParaCredenciales(
      seccional,
      convenio,
      empresa,
      fechaVencimiento,
      nro_afi
    ) {
      return LUM.get(
        API_URL +
          "beneficiarios/traerParaCredenciales/" +
          seccional +
          "/" +
          convenio +
          "/" +
          empresa +
          "/" +
          fechaVencimiento +
          "/" +
          nro_afi
      );
    },
    async modificar(entidad) {
      return LUM.put(API_URL + "beneficiarios", entidad);
    },
    async ModificarDatosContacto(entidad) {
      return LUM.put(API_URL + "beneficiarios/ModificarDatosContacto", entidad);
    },
    async alta(entidad) {
      return LUM.post(API_URL + "beneficiarios", entidad);
    }
  },
  Certificados_Afiliados: {
    async traerPorAfiliado(id_afiliado) {
      return LUM.get(
        API_URL + "Certificados_Afiliados/traerPorAfiliado/" + id_afiliado
      );
    },
    async modificar(entidad) {
      return LUM.put(API_URL + "Certificados_Afiliados", entidad);
    },
    async alta(entidad) {
      return LUM.post(API_URL + "Certificados_Afiliados", entidad);
    }
  },
  Convenios_Planes: {
    async traerPorPlan(id_plan) {
      return LUM.get(API_URL + "Convenios_Planes/traerPorPlan/" + id_plan);
    },
    async modificar(entidad) {
      return LUM.put(API_URL + "Convenios_Planes", entidad);
    },
    async alta(entidad) {
      return LUM.post(API_URL + "Convenios_Planes", entidad);
    }
  },
  Convenios_Prestacionales: {
    Nuevo() {
      let conv = {
        id_convenio: 0,
        descripcion_convenio: "",
        Contacto: "",
        Telefono_contacto: "",
        Celular_contacto: "",
        Telefono_alternativo_contacto: "",
        Domicilio: "",
        id_localidad: 0,
        id_provincia: 0,
        codigo_postal: ""
      };
      return conv;
    },
    async traerTodos() {
      return LUM.get(API_URL + "Convenios_Prestacionales");
    },
    async traerPorDescripcion(denominacion) {
      return LUM.get(
        API_URL + "Convenios_Prestacionales/traerPorDescripcion/" + denominacion
      );
    },
    async modificar(entidad) {
      return LUM.put(API_URL + "Convenios_Prestacionales", entidad);
    },
    async alta(entidad) {
      return LUM.post(API_URL + "Convenios_Prestacionales", entidad);
    },
    desregulados: [3, 5, 7, 9] //no va
  },
  Contratos_Cabecera: {
    async modificar(entidad) {
      return LUM.put(API_URL + "Contratos_Cabecera", entidad);
    },
    async alta(entidad) {
      return LUM.post(API_URL + "Contratos_Cabecera", entidad);
    },
    async traerTodosPorEfector(id_efector) {
      return LUM.get(
        API_URL + "Contratos_Cabecera/traerTodosPorEfector/" + id_efector
      );
    }
  },
  Contratos_Lineas: {
    async traerContratoCompleto(id_contrato) {
      return LUM.get(
        API_URL + "Contratos_Lineas/traerContratoCompleto/" + id_contrato
      );
    },
    async traerContratoCompletoPorCapitulo(id_contrato, capitulo) {
      return LUM.get(
        API_URL +
          `Contratos_Lineas/traerContratoCompletoPorCapitulo/${id_contrato}/${capitulo}`
      );
    },
    async modificar(entidad) {
      return LUM.put(API_URL + "Contratos_Lineas", entidad);
    },
    async alta(entidad) {
      return LUM.post(API_URL + "Contratos_Lineas", entidad);
    },
    async eliminar(id) {
      return LUM.delete(API_URL + "Contratos_Lineas/" + id);
    }
  },
  Contratos_Planes: {
    async traerContratoCompleto(id_contrato) {
      return LUM.get(
        API_URL + "Contratos_Planes/traerContratoCompleto/" + id_contrato
      );
    },
    async traerContratoCompletoPorCapitulo(id_contrato, capitulo) {
      return LUM.get(
        API_URL +
          `Contratos_Planes/traerContratoCompletoPorCapitulo/${id_contrato}/${capitulo}`
      );
    },
    async alta(entidad) {
      return LUM.post(API_URL + "Contratos_Planes", entidad);
    },
    async eliminar(id_contrato, id_practica, id_plan) {
      return LUM.delete(
        API_URL + `Contratos_Planes/${id_contrato}/${id_practica}/${id_plan}`
      );
    },
    async Agregar(id_contrato, id_plan) {
      return LUM.get(
        API_URL + `Contratos_Planes/Agregar/${id_contrato}/${id_plan}`
      );
    },
    async Quitar(id_contrato, id_plan) {
      return LUM.get(
        API_URL + `Contratos_Planes/Quitar/${id_contrato}/${id_plan}`
      );
    }
  },
  Credenciales: {
    async modificar(entidad) {
      return LUM.put(API_URL + "Credenciales", entidad);
    },
    async alta(entidad) {
      return LUM.post(API_URL + "Credenciales", entidad);
    },
    async Generar(listaids, nuevavalidez, lote) {
      return LUM.post(API_URL + "Credenciales/Generar", {
        listaids,
        nuevavalidez,
        lote
      });
    },
    async traerUltimaPorAfiliado(id_afiliado) {
      return LUM.get(
        API_URL + "Credenciales/traerUltimaPorAfiliado/" + id_afiliado
      );
    }
  },
  Diagnostico: {
    async Buscar(problema) {
      return LUM.get(API_URL + `Diagnosticos/Buscar/${problema}==`);
    },
    async traerTodos(problema) {
      return LUM.get(API_URL + `Diagnosticos`);
    },
    async modificar(entidad) {
      return LUM.put(API_URL + "Diagnosticos", entidad);
    },
    async alta(entidad) {
      return LUM.post(API_URL + "Diagnosticos", entidad);
    },
    async eliminar(id) {
      return LUM.delete(API_URL + "Diagnosticos/" + id);
    }
  },
  padron_ospical: {
    async traerPorDNI(dni) {
      return LUM.get(API_URL + "padron_ospical/traerPorNdoc/" + dni);
    }
  },
  Documentacion_afiliados: {
    async traerPorIdAfiliado(idAfiliado) {
      return LUM.get(
        API_URL + "Documentacion_afiliados/PorIdAfiliado/" + idAfiliado
      );
    },
    async modificar(entidad) {
      return LUM.put(API_URL + "Documentacion_afiliados", entidad);
    },
    async alta(entidad) {
      return LUM.post(API_URL + "Documentacion_afiliados", entidad);
    }
  },
  domiciliosprofesionales: {
    async traerUno(id) {
      return LUM.get(API_URL + `domiciliosprofesionales/${id}`);
    },
    async traerPorEfector(idEfector) {
      return LUM.get(
        API_URL + `domiciliosprofesionales/traerPorEfector/${idEfector}`
      );
    },
    async traerParaCartilla(id_plan, id_especialidad, id_provincia, localidad) {
      return LUM.get(
        API_URL +
          `domiciliosprofesionales/traerParaCartilla/${id_plan}/${id_especialidad}/${id_provincia}/${localidad}`
      );
    }
  },
  Efector: {
    async Buscar(razonnombreocuit, id_plan) {
      return LUM.get(
        API_URL + `Efectors/Buscar/${id_plan}/${razonnombreocuit}==`
      );
    },
    async traerPorProvincia(idProvincia, id_plan) {
      return LUM.get(
        API_URL + `Efectors/traerPorProvincia/${id_plan}/${idProvincia}`
      );
    },
    async traerParaCartilla(id_plan, id_especialidad, id_provincia, localidad) {
      return LUM.get(
        API_URL +
          `Efectors/traerParaCartilla/${id_plan}/${id_especialidad}/${id_provincia}/${localidad}`
      );
    },
    async traerUno(id) {
      return LUM.get(API_URL + `Efectors/${id}`);
    },
    async GuardarNuevoPrescriptor(
      nombreNuevoPrescriptor,
      matMunicipal,
      matProvincial
    ) {
      let efec = {
        RAZON_SOCI: nombreNuevoPrescriptor,
        nombreefector: nombreNuevoPrescriptor,
        MatriculaProvincial: matProvincial,
        MatriculaProvincial: matMunicipal,
        Id: 0
      };
      return LUM.post(API_URL + `Efectors`, efec);
    },
    async modificar(entidad) {
      return LUM.put(API_URL + "Efectors", entidad);
    }
  },
  Efector_Plan: {
    async alta(entidad) {
      return LUM.post(API_URL + "Efector_Plan", entidad);
    },
    async eliminar(entidad) {
      return LUM.delete(
        API_URL + `Efector_Plan/${entidad.id_Efector}/${entidad.Id_Plan}`
      );
    }
  },
  Efectores_prestaciones: {
    async traerContratoCompleto(id_efector) {
      return LUM.get(
        API_URL + "Efectores_prestaciones/traerContratoCompleto/" + id_efector
      );
    },
    async traerContratoCompletoPorCapitulo(id_efector, capitulo) {
      return LUM.get(
        API_URL +
          `Efectores_prestaciones/traerContratoCompletoPorCapitulo/${id_efector}/${capitulo}`
      );
    },
    async modificar(entidad) {
      return LUM.put(API_URL + "Efectores_prestaciones", entidad);
    },
    async alta(entidad) {
      return LUM.post(API_URL + "Efectores_prestaciones", entidad);
    },
    async eliminar(id) {
      return LUM.get(API_URL + "Efectores_prestaciones/delete/" + id);
    }
  },
  Empresas: {
    async traerPorDenominacion(denominacion) {
      return LUM.get(
        API_URL + `Empresas/traerPorDenominacion/${denominacion}==`
      );
    },
    async traerPorCuit(denominacion) {
      return LUM.get(API_URL + "Empresas/traerPorCuit/" + denominacion);
    },
    async Buscar(denocuit) {
      return LUM.get(API_URL + "Empresas/Buscar/" + denocuit);
    },
    async modificar(entidad) {
      return LUM.put(API_URL + "Empresas", entidad);
    },
    async alta(entidad) {
      return LUM.post(API_URL + "Empresas", entidad);
    }
  },
  Empresas_Afiliados: {
    async traerPorEmpresa(id_empresa) {
      return LUM.get(
        API_URL + "Empresas_Afiliados/traerPorEmpresa/" + id_empresa
      );
    },
    async traerPorAfiliado(id_afiliado) {
      return LUM.get(
        API_URL + "Empresas_Afiliados/traerPorAfiliado/" + id_afiliado
      );
    },
    async modificar(entidad) {
      return LUM.put(API_URL + "Empresas_Afiliados", entidad);
    },
    async alta(entidad) {
      return LUM.post(API_URL + "Empresas_Afiliados", entidad);
    }
  },
  Especialidades: {
    async traerPorid_plan(id_plan) {
      return LUM.get(API_URL + `Especialidades/traerPorid_plan/${id_plan}`);
    },
    async traerParaCartilla(id_plan, id_especialidad, id_provincia, localidad) {
      return LUM.get(
        API_URL +
          `Especialidades/traerParaCartilla/${id_plan}/${id_especialidad}/${id_provincia}/${localidad}`
      );
    }
  },
  Estado_Civil: {
    async traerTodos() {
      return LUM.get(API_URL + "Estado_Civil");
    }
  },
  FileUploading: {
    async eliminar(id_afiliado, nombre_documento) {
      return LUM.get(
        API_URL + "FileUploading/delete/" + id_afiliado + "/" + nombre_documento
      );
    },

    async eliminarImagen(IdImagenes, nombre_documento) {
      return LUM.get(
        API_URL +
          "FileUploading/deleteImagen/" +
          IdImagenes +
          "/" +
          nombre_documento
      );
    },
    async eliminarimagen_certificado(id_certificado, nombre_documento) {
      return LUM.get(
        API_URL +
          "FileUploading/deleteimagen_certificado/" +
          id_certificado +
          "/" +
          nombre_documento
      );
    }
  },
  ImagenesPracticas: {
    async traerPorIdImagenes(IdImagenes) {
      return LUM.get(API_URL + "ImagenesPracticas/PorIdImagenes/" + IdImagenes);
    },
    async modificar(entidad) {
      return LUM.put(API_URL + "ImagenesPracticas", entidad);
    },
    async alta(entidad) {
      return LUM.post(API_URL + "ImagenesPracticas", entidad);
    }
  },
  Imagen_Certificado: {
    async traerPorCertificado(id_certificado) {
      return LUM.get(
        API_URL + "Imagen_Certificado/traerPorCertificado/" + id_certificado
      );
    }
  },
  Internaciones: {
    async traerPorAfiliado(id_afiliado) {
      return LUM.get(API_URL + "Internaciones/traerPorAfiliado/" + id_afiliado);
    },
    async traerPorArea(id_area) {
      return LUM.get(API_URL + "Internaciones/traerPorArea/" + id_area);
    },
    async traerinternacionEnCurso(id_afiliado) {
      return LUM.get(
        API_URL + "Autorizaciones/traerInternacionEnCurso/" + id_afiliado
      );
    },
    async modificar(entidad) {
      return LUM.put(API_URL + "Internaciones", entidad);
    },
    async alta(entidad) {
      return LUM.post(API_URL + "Internaciones", entidad);
    },
    async evaluarEstado(
      id_afiliado,
      cantidad,
      cod_nom,
      id_efector,
      id_efectorprofesional
    ) {
      return LUM.get(
        API_URL +
          `Internaciones/evaluarEstado/${id_afiliado}/${cantidad}/${cod_nom}/${id_efector}/${id_efectorprofesional}`
      );
    }
  },
  Lineas: {
    async traerTodos() {
      return LUM.get(API_URL + "Lineas");
    },
    async modificar(entidad) {
      return LUM.put(API_URL + "Lineas", entidad);
    },
    async alta(entidad) {
      return LUM.post(API_URL + "Lineas", entidad);
    },
    async eliminar(id) {
      return LUM.delete(API_URL + "Lineas/" + id);
    }
  },
  Lineas_Laboratorio: {
    // async traerTodos() {
    //   return LUM.get(API_URL + 'Lineas_Laboratorio')
    // },
    async traerPorId(id) {
      return LUM.get(API_URL + "Lineas_Laboratorio/" + id);
    },
    async modificar(entidad) {
      return LUM.put(API_URL + "Lineas_Laboratorio", entidad);
    },
    async alta(entidad) {
      return LUM.post(API_URL + "Lineas_Laboratorio", entidad);
    },
    async eliminar(id) {
      return LUM.delete(API_URL + "Lineas_Laboratorio/" + id);
    }
  },
  Localidades: {
    async traerPorid_plan(id_plan) {
      return LUM.get(API_URL + `Localidades/traerPorid_plan/${id_plan}`);
    },
    async traerParaCartilla(id_plan, id_especialidad, id_provincia, localidad) {
      return LUM.get(
        API_URL +
          `Localidades/traerParaCartilla/${id_plan}/${id_especialidad}/${id_provincia}/${localidad}`
      );
    },
    async traerTodos() {
      return LUM.get(API_URL + "Localidades");
    }
  },
  Motivos: {
    async traerTodos() {
      return LUM.get(API_URL + "Motivos");
    },
    async modificar(entidad) {
      return LUM.put(API_URL + "Motivos", entidad);
    },
    async alta(entidad) {
      return LUM.post(API_URL + "Motivos", entidad);
    },
    async eliminar(id) {
      return LUM.delete(API_URL + "Motivos/" + id);
    }
  },
  Motivos_de_baja: {
    async traerTodos() {
      return LUM.get(API_URL + "Motivos_de_baja");
    },
    async modificar(entidad) {
      return LUM.put(API_URL + "Motivos_de_baja", entidad);
    },
    async alta(entidad) {
      return LUM.post(API_URL + "Motivos_de_baja", entidad);
    },
    async eliminar(id) {
      return LUM.get(API_URL + "Motivos_de_baja/delete/" + id);
    }
  },
  MotivosCierre: {
    async traerTodos() {
      return LUM.get(API_URL + "MotivosCierre");
    },
    async modificar(entidad) {
      return LUM.put(API_URL + "MotivosCierre", entidad);
    },
    async alta(entidad) {
      return LUM.post(API_URL + "MotivosCierre", entidad);
    },
    async eliminar(id) {
      return LUM.get(API_URL + "MotivosCierre/delete/" + id);
    }
  },
  Motivo_baja_empresa: {
    async traerTodos() {
      return LUM.get(API_URL + "Motivo_baja_empresa");
    },
    async modificar(entidad) {
      return LUM.put(API_URL + "Motivo_baja_empresa", entidad);
    },
    async alta(entidad) {
      return LUM.post(API_URL + "Motivo_baja_empresa", entidad);
    },
    async eliminar(id) {
      return LUM.get(API_URL + "Motivo_baja_empresa/delete/" + id);
    }
  },
  Motivo_baja_Efector: {
    async traerTodos() {
      return LUM.get(API_URL + "Motivo_baja_Efector");
    },
    async modificar(entidad) {
      return LUM.put(API_URL + "Motivo_baja_Efector", entidad);
    },
    async alta(entidad) {
      return LUM.post(API_URL + "Motivo_baja_Efector", entidad);
    },
    async eliminar(id) {
      return LUM.get(API_URL + "Motivo_baja_Efector/delete/" + id);
    }
  },
  Nacionalidades: {
    async traerTodos() {
      return LUM.get(API_URL + "Nacionalidades");
    }
  },
  Nomenclador: {
    async traerTodos() {
      return LUM.get(API_URL + "baso001");
    }
  },
  Observaciones: {
    async alta(entidad) {
      return LUM.post(API_URL + "Observaciones", entidad);
    },
    async eliminar(id) {
      return LUM.get(API_URL + "Observaciones/delete/" + id);
    }
  },
  ObservacionesInternas: {
    async alta(entidad) {
      return LUM.post(API_URL + "ObservacionesInternas", entidad);
    }
  },
  Observaciones_Afiliados: {
    async traerPorIdAfiliado(id_afiliado) {
      return LUM.get(
        API_URL + "Observaciones_Afiliados/traerPorIdAfiliado/" + id_afiliado
      );
    },
    async modificar(entidad) {
      return LUM.put(API_URL + "Observaciones_Afiliados", entidad);
    },
    async alta(entidad) {
      return LUM.post(API_URL + "Observaciones_Afiliados", entidad);
    },
    async eliminar(id) {
      return LUM.get(API_URL + "Observaciones_Afiliados/delete/" + id);
    }
  },
  Parentesco: {
    async traerTodos() {
      return LUM.get(API_URL + "Parentesco");
    }
  },
  Patologias: {
    async traerTodos() {
      return LUM.get(API_URL + "Patologias");
    },
    async modificar(entidad) {
      return LUM.put(API_URL + "Patologias", entidad);
    },
    async alta(entidad) {
      return LUM.post(API_URL + "Patologias", entidad);
    },
    async eliminar(id) {
      return LUM.delete(API_URL + "Patologias/" + id);
    }
  },
  PatologiasBeneficiarios: {
    async modificar(entidad) {
      return LUM.put(API_URL + "PatologiasBeneficiarios", entidad);
    },
    async alta(entidad) {
      return LUM.post(API_URL + "PatologiasBeneficiarios", entidad);
    },
    async eliminar(id) {
      return LUM.delete(API_URL + "PatologiasBeneficiarios/" + id);
    },
    async traer(id) {
      return LUM.delete(API_URL + "PatologiasBeneficiarios/" + id);
    }
  },
  Planes: {
    async traerTodos() {
      return LUM.get(API_URL + "Planes");
    },
    async traerSegunConvenio(id_convenio) {
      return LUM.get(API_URL + "Planes/traerSegunConvenio/" + id_convenio);
    },
    async modificar(entidad) {
      return LUM.put(API_URL + "Planes", entidad);
    },
    async alta(entidad) {
      return LUM.post(API_URL + "Planes", entidad);
    },
    async eliminar(id) {
      return LUM.get(API_URL + "Planes/delete/" + id);
    },
    desregulados: [3, 4]
  },
  Prorrogas: {
    async traerTodos() {
      return LUM.get(API_URL + "Prorrogas");
    },
    async modificar(entidad) {
      return LUM.put(API_URL + "Prorrogas", entidad);
    },
    async alta(entidad) {
      return LUM.post(API_URL + "Prorrogas", entidad);
    },
    async eliminar(id) {
      return LUM.delete(API_URL + "Prorrogas/" + id);
    }
  },
  Provincias: {
    // _Todas: [],
    // todas() {
    //   if (this._Todas.length === 0) {
    //     this.traerTodos().then((provincias) => {
    //       this._Todas = provincias;
    //     });
    //   } else {
    //     return Promise.resolve(this._Todas);
    //   }
    //   return this._Todas;
    // },
    // traerUna(id) {
    //   return this.todas().find((provincia) => provincia.id === id);
    // },
    async traerPorid_plan(id_plan) {
      return LUM.get(API_URL + `Provincias/traerPorid_plan/${id_plan}`);
    },
    async traerTodos() {
      return LUM.get(API_URL + "Provincias");
    },
    async traerParaCartilla(id_plan, id_especialidad, id_provincia, localidad) {
      return LUM.get(
        API_URL +
          `Provincias/traerParaCartilla/${id_plan}/${id_especialidad}/${id_provincia}/${localidad}`
      );
    }
  },
  Reportes: {
    async traerTodos() {
      return LUM.get(API_URL + "Reportes/traerPorSitioPorUsuarioLogueado/5");
    }
  },
  Seccionales: {
    async traerTodos() {
      return LUM.get(API_URL + "Seccionales");
    },
    async modificar(entidad) {
      return LUM.put(API_URL + "Seccionales", entidad);
    },
    async alta(entidad) {
      return LUM.post(API_URL + "Seccionales", entidad);
    },
    async eliminar(id) {
      return LUM.get(API_URL + "Seccionales/delete/" + id);
    }
  },
  Sectores: {
    async traerTodos() {
      return LUM.get(API_URL + "SectoresInternacions");
    },
    async modificar(entidad) {
      return LUM.put(API_URL + "SectoresInternacions", entidad);
    },
    async alta(entidad) {
      return LUM.post(API_URL + "SectoresInternacions", entidad);
    },
    async eliminar(id) {
      return LUM.delete(API_URL + "SectoresInternacions/" + id);
    }
  },
  Situacion_Revista: {
    async traerTodos() {
      return LUM.get(API_URL + "Situacion_Revista");
    },
    async modificar(entidad) {
      return LUM.put(API_URL + "Situacion_Revista", entidad);
    },
    async alta(entidad) {
      return LUM.post(API_URL + "Situacion_Revista", entidad);
    },
    async eliminar(id) {
      return LUM.get(API_URL + "Situacion_Revista/delete/" + id);
    }
  },
  Telefonos_Efectores: {
    async modificar(entidad) {
      return LUM.put(API_URL + "Telefonos_Efectores", entidad);
    },
    async alta(entidad) {
      return LUM.post(API_URL + "Telefonos_Efectores", entidad);
    },
    async eliminar(id) {
      return LUM.delete(API_URL + "Telefonos_Efectores/" + id);
    }
  },
  Tipo_Autorizacion: {
    _Todos: [],
    async Todos() {
      if (this._Todos.length === 0) {
        this._Todos = await LUM.get(API_URL + "Tipos");
      }
      return this._Todos;
    }
  },
  Tipo_Afiliacion: {
    async traerTodos() {
      return LUM.get(API_URL + "Tipo_Afiliacion");
    },
    async modificar(entidad) {
      return LUM.put(API_URL + "Tipo_Afiliacion", entidad);
    },
    async alta(entidad) {
      return LUM.post(API_URL + "Tipo_Afiliacion", entidad);
    },
    async eliminar(id) {
      return LUM.get(API_URL + "Tipo_Afiliacion/delete/" + id);
    }
  },
  Tipo_certificados: {
    async traerTodos() {
      return LUM.get(API_URL + "Tipo_certificados");
    }
  },
  Tipo_documento: {
    async traerTodos() {
      return LUM.get(API_URL + "Tipo_documento");
    }
  },
  Tipo_documentaciones: {
    async traerTodos() {
      return LUM.get(API_URL + "Tipo_documentaciones");
    },
    async modificar(entidad) {
      return LUM.put(API_URL + "Tipo_documentaciones", entidad);
    },
    async alta(entidad) {
      return LUM.post(API_URL + "Tipo_documentaciones", entidad);
    },
    async eliminar(id) {
      return LUM.get(API_URL + "Tipo_documentaciones/delete/" + id);
    }
  },
  Tipo_documentaciones_tipo_afiliacion: {
    async traerTodos() {
      return LUM.get(API_URL + "Tipo_documentaciones_tipo_afiliacion");
    },
    // async traerPorTipo_Afiliacion(tipo, parentesco) {
    //   if (parentesco == 0) {
    //     return LUM.get(API_URL + 'Tipo_documentaciones_tipo_afiliacion/traerPorTipo_Afiliacion/' + tipo);
    //   } else {
    //     return LUM.get(API_URL + 'Tipo_documentaciones_parentesco/traerPorparentesco/' + parentesco);
    //   }
    // },
    async traerPorTipo_Afiliacion(tipoAfiliacion, parentesco) {
      if (parentesco == 0) {
        return LUM.get(
          API_URL +
            "Tipo_documentaciones_tipo_afiliacion/traerPorTipo_Afiliacion/" +
            tipoAfiliacion
        );
      } else {
        return LUM.get(
          API_URL +
            "Tipo_documentaciones_parentesco/traerPorParentesco/" +
            parentesco
        );
      }
    },
    async modificar(entidad) {
      return LUM.put(API_URL + "Tipo_documentaciones_tipo_afiliacion", entidad);
    },
    async alta(entidad) {
      return LUM.post(
        API_URL + "Tipo_documentaciones_tipo_afiliacion",
        entidad
      );
    },
    async Agregar(id_tipo_afiliacion, id_tipo_documentaciones, Obligatorio) {
      let p = {
        id_tipo_documentaciones_tipo_afiliacion: 0,
        id_tipo_documentaciones,
        id_tipo_afiliacion,
        Obligatorio
      };
      return LUM.post(API_URL + "Tipo_documentaciones_tipo_afiliacion", p);
    },
    async Quitar(id_tipo_documentaciones, id_tipo_afiliacion) {
      return LUM.get(
        API_URL +
          `Tipo_documentaciones_tipo_afiliacion/delete/${id_tipo_documentaciones}/${id_tipo_afiliacion}`
      );
    }
  },
  Tipo_documentaciones_parentesco: {
    async traerTodos() {
      return LUM.get(API_URL + "Tipo_documentaciones_parentesco");
    },
    async traerPorParentesco(parentesco) {
      return LUM.get(
        API_URL +
          "Tipo_documentaciones_parentesco/traerPorParentesco/" +
          parentesco
      );
    },
    async modificar(entidad) {
      return LUM.put(API_URL + "Tipo_documentaciones_parentesco", entidad);
    },
    async alta(entidad) {
      return LUM.post(API_URL + "Tipo_documentaciones_parentesco", entidad);
    },
    async Agregar(id_parentesco, id_tipo_documentaciones, Obligatorio) {
      let p = {
        id_tipo_documentaciones_parentesco: 0,
        id_tipo_documentaciones,
        id_parentesco,
        Obligatorio
      };
      return LUM.post(API_URL + "Tipo_documentaciones_parentesco", p);
    },
    async Quitar(id_tipo_documentaciones, id_tipo_afiliacion) {
      return LUM.get(
        API_URL +
          `Tipo_documentaciones_parentesco/delete/${id_tipo_documentaciones}/${id_parentesco}`
      );
    }
  },
  TiposDePrestadores: {
    async traerTodos() {
      return LUM.get(API_URL + "TiposDePrestadores");
    },
    async modificar(entidad) {
      return LUM.put(API_URL + "TiposDePrestadores", entidad);
    },
    async alta(entidad) {
      return LUM.post(API_URL + "TiposDePrestadores", entidad);
    },
    async eliminar(id) {
      return LUM.get(API_URL + "TiposDePrestadores/delete/" + id);
    }
  },
  TiposDePrestadores_Legales: {
    async traerTodos() {
      return LUM.get(API_URL + "TiposDePrestadores_Legales");
    },
    async modificar(entidad) {
      return LUM.put(API_URL + "TiposDePrestadores_Legales", entidad);
    },
    async alta(entidad) {
      return LUM.post(API_URL + "TiposDePrestadores_Legales", entidad);
    },
    async eliminar(id) {
      return LUM.get(API_URL + "TiposDePrestadores_Legales/delete/" + id);
    }
  },
  Tracking_Estados: {
    async traerUltimo(id_solic) {
      return LUM.get(API_URL + `Tracking_Estados/traerUltimo/${id_solic}`);
    }
  },
  Usuarios: {
    Todos: [],
    async traerPermisosDelUsuarioEnElSitio() {
      //autorizador es el sitio 5
      return LUM.get(API_URL + "Permisos/traerPorSitioPorUsuarioLogueado/5");
    },
    async traerUsuarioLogueado() {
      //autorizador es el sitio 5
      return LUM.get(API_URL + "usuarios/logueado");
    },
    async traerUno(id) {
      let ret = this.Todos.find((x) => x.id_usuario == id);
      if (ret == undefined) {
        ret = await LUM.get(API_URL + "usuarios/" + id);
        this.Todos.push(ret);
      }
      return ret;
    },
    async Loguear(dni, contrasena) {
      let ret = await LUM.postSinToken(
        API_URL + `login/autenticarbeneficiario/`,
        {
          Username: dni,
          Password: contrasena
        }
      );
      return ret;
    },
    async LoguearEfector(email, password) {
      let ret = await LUM.postSinToken(API_URL + `login/autenticarefector/`, {
        Username: email,
        Password: password
      });
      return ret;
    },
    async LoguearCartilla() {
      let ret = await LUM.postSinToken(API_URL + `login/autenticarcartilla/`);
      return ret;
    }
  },
  UsuariosEfectores: {
    async modificar(entidad) {
      return LUM.put(API_URL + "UsuariosEfectores", entidad);
    },
    async eliminar(id) {
      return LUM.delete(API_URL + "UsuariosEfectores/" + id);
    },
    async registrar(datos) {
      return LUM.post(API_URL + "UsuariosEfectores/Registrar", datos);
    }
  },
  UsuariosBeneficiarios: {
    async alta(entidad) {
      return LUM.post(API_URL + "UsuariosBeneficiarios", entidad);
    },
    async modificar(entidad) {
      return LUM.put(API_URL + "UsuariosBeneficiarios", entidad);
    },
    async recuperarcontrasena(mail) {
      return LUM.get(
        API_URL + "UsuariosBeneficiarios/RecuperarContrasena/" + mail
      );
    },
    async RecuperarPass(entidad) {
      return LUM.put(API_URL + "UsuariosBeneficiarios/RecuperarPass", entidad);
    }
  },
  Zonas: {
    async traerTodos() {
      return LUM.get(API_URL + "Zonas");
    },
    async modificar(entidad) {
      return LUM.put(API_URL + "Zonas", entidad);
    },
    async alta(entidad) {
      return LUM.post(API_URL + "Zonas", entidad);
    },
    async eliminar(id) {
      return LUM.get(API_URL + "Zonas/delete/" + id);
    }
  }
};
